import React from "react";

const MESSAGES = [
  "Applications open for AI Innovation Arena Mega Finale — December Edition",
  "The AI For Everyone platform debuts Q3 2026 — reserve early access below",
  "Inaugural HIT Edition · 1,000+ attended · 70 pods · 15 builders being backed",
  "Schools · Colleges · Corporates worldwide — bring the Arena to your region",
];

export default function AnnouncementBar() {
  // Triple the strip so the marquee never reveals an edge
  const strip = [...MESSAGES, ...MESSAGES, ...MESSAGES];
  return (
    <div
      className="w-full text-canvas overflow-hidden"
      style={{ background: "var(--ink)" }}
      data-testid="announcement-bar"
    >
      <div className="container-edge h-10 flex items-center gap-6">
        <div className="flex items-center gap-3 shrink-0">
          <span className="live-dot" aria-hidden="true" />
          <span
            className="font-mono text-[11px]"
            style={{ color: "var(--accent-gold)", letterSpacing: "0.18em" }}
          >
            LIVE
          </span>
        </div>

        <div
          className="relative flex-1 overflow-hidden"
          style={{
            maskImage:
              "linear-gradient(to right, transparent 0, #000 6%, #000 94%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0, #000 6%, #000 94%, transparent 100%)",
          }}
        >
          <div
            className="marquee-track flex items-center whitespace-nowrap gap-12"
            data-testid="announcement-marquee"
          >
            {strip.map((m, i) => (
              <span key={i} className="inline-flex items-center gap-12">
                <span
                  className="font-mono text-[12px]"
                  style={{ color: "rgba(250,250,247,0.85)", letterSpacing: "0.04em" }}
                >
                  {m}
                </span>
                <span
                  className="inline-block w-1 h-1 rounded-full"
                  style={{ background: "var(--accent-gold)" }}
                  aria-hidden="true"
                />
              </span>
            ))}
          </div>
        </div>

        <a
          href="#enquiry"
          data-testid="announcement-apply-link"
          className="font-mono text-[12px] link-underline shrink-0 hidden sm:inline"
          style={{ color: "var(--canvas)" }}
        >
          Apply →
        </a>
      </div>
    </div>
  );
}
